Object.defineProperty(exports, '__esModule', {
  value: true
});
var getInitials = function getInitials(fullname) {
  if (fullname === void 0) {
    fullname = "Anonymous User";
  }
  var nameParts = fullname.replace("@theaa.com", "").replace(".", " ").split(" ");
  if (nameParts.length > 2) {
    nameParts = [nameParts[0], nameParts[nameParts.length - 1]];
  }
  return nameParts.reduce(function (acc, name) {
    return "" + acc + name.charAt(0);
  }, "").toUpperCase();
};
var slashSeparatedToHyphenSeparated = function slashSeparatedToHyphenSeparated(value) {
  return value.replace(/\//g, "-");
};
var camelCaseToSpacedPascalCase = function camelCaseToSpacedPascalCase(text) {
  return text.toLowerCase().replace(/\//g, "").split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
};
/**
 * Uppercases the first character of the given string.
 * @example
 * // returns "Cat"
 * upperCaseFirstCharacter("cat");
 * @param str The string to upercase the first character of.
 */
var upperCaseFirstCharacter = function upperCaseFirstCharacter(str) {
  return str.length ? "" + str[0].toUpperCase() + str.slice(1) : "";
};
exports.camelCaseToSpacedPascalCase = camelCaseToSpacedPascalCase;
exports.getInitials = getInitials;
exports.slashSeparatedToHyphenSeparated = slashSeparatedToHyphenSeparated;
exports.upperCaseFirstCharacter = upperCaseFirstCharacter;